import en from 'src/i18n/en';
import fr from 'src/i18n/fr';

const language = {
  en,
  fr,
};

export default language;
